"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionTier = subscriptionTier;
require("@branch-ts/business-consensus");
/** The prevailing cycle, not a future plan or retained checkout, owns the current tier. */
function subscriptionTier(subscription, now = Date.now()) {
    if (!subscription)
        return { name: "Unavailable", className: "tier-unknown", expiresAt: undefined };
    const cycle = subscription.prevail;
    const active = subscription.state.startsWith("active") && cycle
        && cycle.accident !== "cancelNow" && cycle.start <= now && now < cycle.end;
    const name = active ? cycle.tier : "free";
    return {
        name: name.charAt(0).toUpperCase() + name.slice(1),
        className: name !== "free" ? "tier-paid" : "tier-free",
        expiresAt: active ? cycle.end : undefined,
    };
}
